export default __webpack_public_path__ + "static/media/execution_2.938c4320.png";